import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqItem } from '../../../interfaces/faq.interface';

@Component({
    selector: 'app-accordion-item',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './accordion-item.component.html',
    styleUrls: ['./accordion-item.component.scss']
})
export class AccordionItemComponent {
    @Input() item!: FaqItem;

    toggleAccordion(): void {
        this.item.isOpen = !this.item.isOpen;
    }
} 